const EXPERIMENT = 'free_library_v2';
const LIBRARY_SOURCES = ['save_intent', 'try_color_library', 'learn_more_library', 'home_intro'];

const isLibrarySource = (source) => LIBRARY_SOURCES.includes(source);
const isLibraryToolReturn = (path) =>
    typeof path === 'string' &&
    /^\/(?:color-details|color-harmonies|color-mixer|color-style-guide|color-theme|color-tones|color-wheel|dominant-image-colors|lighten-and-darken|tints-and-shades|colors\/[0-9a-fA-F]{6})\/$/.test(
        path,
    );

const canUseColorLibrary = (user) => user?.accountReady === true;

const saveIntentAction = (user) => {
    if (!user) return 'authenticate';
    return canUseColorLibrary(user) ? 'save' : 'pending';
};

const premiumCtaAction = (user) => (user ? 'open_library' : 'signup');

const provisioningState = (user) => {
    if (!user || user.loading !== false) return 'pending';
    return canUseColorLibrary(user) ? 'active' : 'inactive';
};

const signupDestination = ({ state }) => {
    return state === 'active' ? '/app/color-library/' : undefined;
};

const signupState = (source) => ({
    signupSource: isLibrarySource(source) ? source : 'direct',
    ...(isLibrarySource(source) ? { experiment: EXPERIMENT, returnTo: '/app/color-library/' } : {}),
});

module.exports = {
    EXPERIMENT,
    LIBRARY_SOURCES,
    canUseColorLibrary,
    isLibrarySource,
    isLibraryToolReturn,
    premiumCtaAction,
    provisioningState,
    saveIntentAction,
    signupDestination,
    signupState,
};
